export default "__VITE_ASSET__Dso8nJXt__"